export default __webpack_public_path__ + "static/media/card-image16.96721390.png";